import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHoppscotchComponent } from './simple-icons-hoppscotch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHoppscotchComponent ],
    exports:      [ SimpleIconsHoppscotchComponent ],
    bootstrap:    []
})
export class SimpleIconsHoppscotchModule {}
